//tslint:disable:max-line-length
const styles = require('./pin-gk.css');

export const pinGK = `
  <div class='${styles['pin-gk']}' />
`;
